/**
 * @packageDocumentation
 * @module StockChartShared
 */
import { Injectable } from '@angular/core';
import { isNullOrUndefined } from 'util';
import * as moment from 'moment';

import { Moment } from 'moment';
import { addYear, subtractYear, isEmptyField } from './stock-chart-util.service';

@Injectable({
  providedIn: 'root'
})
export class StockChartDateFormatService {

  constructor() { }

  isLeapYear(year) {
    return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));
  }

  getDaysInMonth(year, month) {
    return [31, (this.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
  }


  getMinMaxDate(year, month) {
    // tslint:disable-next-line: radix
    year = parseInt(year);
    // tslint:disable-next-line: radix
    month = parseInt(month) + 1;
    const minYearObj: any = {};
    const maxYearObj: any = {};
    minYearObj.year = year;
    maxYearObj.year = year;
    if (!isNullOrUndefined(month)) {
      minYearObj.month = month;
      maxYearObj.month = month;
    } else {
      minYearObj.month = 1;
      maxYearObj.month = 12;
    }
    minYearObj.day = 1;
    maxYearObj.day = this.getDaysInMonth(year, maxYearObj.month - 1);
    return [minYearObj, maxYearObj];
  }

  addMonths = (value, dateObj) => {
    dateObj = new Date(dateObj);
    const n = dateObj.getDate();
    dateObj.setDate(1);
    dateObj.setMonth(dateObj.getMonth() + value);
    dateObj.setDate(Math.min(n, this.getDaysInMonth(dateObj.getFullYear(), dateObj.getMonth())));
    return dateObj;
  }

  formatToNgbDatePicker(value, format, delimiter?: any) {
    const mapping = {
      yyyy: 'year',
      mm: 'month',
      dd: 'day'
    };
    const ngbDatePickerObj: any = {};
    if (format === 'dateObj') {
      ngbDatePickerObj.year = value.getFullYear();
      ngbDatePickerObj.month = value.getMonth() + 1;
      ngbDatePickerObj.day = value.getDate();
    } else {
      const dateFormat = format.split(delimiter);
      const dateList = value.split(delimiter);
      for (let index = 0; index < dateFormat.length; index++) {

        // tslint:disable-next-line: radix
        ngbDatePickerObj[mapping[dateFormat[index]]] = parseInt(dateList[index]);
      }
    }
    return ngbDatePickerObj;
  }

  formatNgbDateToNormalDate(value, format?: any) {
    let returnString = format;
    returnString = returnString.replace('year', value.year);
    returnString = returnString.replace('month', this.prefixZero(value.month));
    returnString = returnString.replace('day', this.prefixZero(value.day));
    return returnString;
    // delimiter = !isNullOrUndefined(delimiter) ? delimiter :
  }

  formatNgbDateToNormalTime(value, format?: any) {
    let returnString = format;
    returnString = returnString.replace('hour', this.prefixZero(value.hour));
    returnString = returnString.replace('minute', this.prefixZero(value.minute));
    // returnString = returnString.replace('second',this.prefixZero(value.day))
    return returnString;
    // delimiter = !isNullOrUndefined(delimiter) ? delimiter :
  }

  formatToNgbTimePicker(value, format, delimiter?: any) {
    const mapping = {
      hh: 'hour',
      mm: 'minute'
    };
    const ngbTimePickerObj: any = {};
    const dateFormat = format.split(delimiter);
    const dateList = value.split(delimiter);
    for (let index = 0; index < dateFormat.length; index++) {
      // tslint:disable-next-line: radix
      ngbTimePickerObj[mapping[dateFormat[index]]] = parseInt(dateList[index]);
    }
    return ngbTimePickerObj;
  }

  generateDateTimeString(date, time) {
    return this.prefixZero(date.day) + '-' + this.prefixZero(date.month) + '-' + date.year + ' ' + time.hour + ':' + time.minute;
  }

  prefixZero(value) {
    return value < 10 ? '0' + value.toString() : value;
  }

  formatToMoment(dateString, format?) {
    if (isEmptyField(dateString)) {
      return;
    }
    const defaultFormat = 'yyyymmdd';
    if (!format) {
      format = defaultFormat;
    }
    const dateStringArray = dateString.split('');
    const formatArray = format.split('');
    let dateObject: any = {
      day: 1,
      month: 1,
      year: new Date().getFullYear()
    };
    let graceIndex = -1;
    for (let index = 0; index < formatArray.length ; index ++) {
      const dateString = formatArray[index];
      if (index < graceIndex) { continue;}
      if (dateString === 'd' || dateString === 'm') {
        graceIndex = index + 2;
        dateObject[dateString === 'd' ? 'day' : 'month'] = dateStringArray[index] + dateStringArray[index + 1];
      } else if (dateString === 'y') {
        graceIndex = index + 4;
        dateObject.year = dateStringArray[index] + dateStringArray[index + 1] + dateStringArray[index + 2] + dateStringArray[index + 3];
      }
    }
    return moment(dateObject.year + '/' + dateObject.month + '/' + dateObject.day);
  }

  formatFromMoment(moment: Moment, format?) {
    const defaultFormat = 'yyyymmdd';
    if (!format) {
      format = defaultFormat;
    }
    const formatArray = format.split('')
    const year = moment.year();
    const month = this.prefixZero(moment.month() + 1);
    const day = this.prefixZero(moment.date());

    let date = '';

    let graceIndex = -1;
    for (let index = 0; index < formatArray.length ; index ++) {
      const dateString = formatArray[index];
      if (index < graceIndex) { continue; }
      if (dateString === 'd' || dateString === 'm') {
        graceIndex = index + 2;
        date = date + (dateString === 'd' ? day : month);
      } else if (dateString === 'y') {
        graceIndex = index + 4;
        date = date + year;
      }
    }
    return date;
  }

  addYears(date, yearCount) {
    if (!moment.isMoment(date)) {
      date = this.formatToMoment(date);
    }
    date = addYear(date, yearCount);
    return this.formatFromMoment(date);
  }

  subTractYears(date, yearCount) {
    if (!moment.isMoment(date)) {
      date = this.formatToMoment(date);
    }
    date = subtractYear(date, yearCount);
    return this.formatFromMoment(date);
  }




}
